export default class TypeObject {
  constructor(name, type, templateTypes) {
    this.name = name;
    this.type = type;
    this.templateTypes = templateTypes;
  }
}
